import CheckIcon from '@mui/icons-material/Check';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { IModalBase } from '../../modules/commonTypes';
import { IDevice } from '../../modules/devices/store/deviceStore';
import ActionModal from '../_DesignSystemWrappers/Modal/ActionModal';
import { useGetAvailableCreditModalData } from './hooks/useGetAvailableCreditModalData';
import messages from './messages';

interface IAvailableCreditModal extends IModalBase {
  device?: Pick<IDevice, 'id'>;
  onSuccess?: () => void;
}

function AvailableCreditModal({ device, onClose, onSuccess, open }: IAvailableCreditModal) {
  const { formatMessage, isLoading, onSubmit } = useGetAvailableCreditModalData(onClose, device?.id, onSuccess);

  return (
    <ActionModal
      icon={<CheckIcon />}
      isPrimaryButtonDisabled={isLoading}
      isPrimaryButtonLoading={isLoading}
      muiDialogProps={{
        maxWidth: 'xs',
      }}
      onClose={onClose}
      open={open}
      primaryButtonAction={onSubmit}
      primaryButtonDataTestId="use-credits-confirm"
      primaryButtonText={formatMessage(messages.AvailableCreditModalConfirmBtn)}
      secondaryButtonText={formatMessage(messages.AvailableCreditModalCancelBtn)}
      title={formatMessage(messages.AvailableCreditModalModalTitle)}
    >
      <Stack spacing={1} sx={{ my: 2.5 }}>
        <Typography>
          <FormattedMessage {...messages.AvailableCreditModalMessage2} />
        </Typography>
      </Stack>
    </ActionModal>
  );
}

export default AvailableCreditModal;
